import {
  DynamicExperienceSearchData,
  UseDynamicExperienceSearch,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "dynamicExperienceSearch";

const useDynamicExperienceSearch: UseDynamicExperienceSearch = ({
  enabled = true,
} = {}) => {
  const { isLoading, value } = useMonarchRule<{
    data: DynamicExperienceSearchData;
  }>(CUSTOM_RULE_ID, {}, { enabled });

  // If not enabled, skip Monarch entirely — return control immediately so callers don't wait.
  if (!enabled) {
    return {
      isLoading: false,
      variant: "control",
    };
  }

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    };
  }

  const { data } = value;
  const variant = data?.enabled ? "test" : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useDynamicExperienceSearch;
